import { render } from "./ChildrenEditModal.vue?vue&type=template&id=7f08fabc"
import script from "./ChildrenEditModal.vue?vue&type=script&lang=js"
export * from "./ChildrenEditModal.vue?vue&type=script&lang=js"

import "./ChildrenEditModal.vue?vue&type=style&index=0&id=7f08fabc&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__